import { DetailsFullscreenMap, PastReservations, RefundedReservations, ReservationDetails, Reservations } from '../pages'

export const reservationsUrls = {
  reservations: '/reservations',
  pastReservations: '/past-reservations',
  refundedReservations: '/refunded-reservations',
  reservationDetails: '/reservation',
  detailsFullscreenMap: '/details-fullscreen-Map'
}

export const reservationsRoutes = [
  { content: Reservations, url: reservationsUrls.reservations, isAuthenticated: true },
  { content: PastReservations, url: reservationsUrls.pastReservations, isAuthenticated: true },
  { content: RefundedReservations, url: reservationsUrls.refundedReservations, isAuthenticated: true },
  { content: ReservationDetails, url: reservationsUrls.reservationDetails, isAuthenticated: true },
  { content: ReservationDetails, url: reservationsUrls.reservationDetails + '/:id', isAuthenticated: true },
  { content: DetailsFullscreenMap, url: reservationsUrls.detailsFullscreenMap, isAuthenticated: true }
]
